import React from 'react';
import Head from "next/head";

const BreadcrumbListSchema = ({params}) => {
    let listItemsSchema = [];

    if (params.length) {
        for (let key in params) {
            const item = params[key];

            listItemsSchema.push({
                "@context": "https://schema.org",
                "@type": "ListItem",
                "position": key + 1,

                "item": {
                    "@context": "https://schema.org",
                    "@type": "Thing",
                    "@id": 'https://www.2nabsh.com' + item.url,
                    'name': item.name,
                }
            })
        }
    }

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": listItemsSchema
    };

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(structuredData)}}
            />
        </Head>
    );
};

export default React.memo(BreadcrumbListSchema);
